export const BRAND_CENTER_PATH = '/brand/brand-guidelines';
export const BRAND_SOURCES_PATH = '/brand/sources';
export const CONTENT_LIBRARY_PATH = '/brand/content-library';
export const BRAND_STRATEGY_PATH = '/brand/strategy';
export const BRAND_OFFERS_PATH = '/brand/offers';

// React Query cache keys (migrated from sources/constants)
export const brandingStatusKey = 'bcc_has_shop_branding';
export const brandingKey = 'bcc_shop_branding';
export const previewMessagesKey = 'bcc_preview_messages';
export const inpirationMessagesKey = 'bcc_im_messages';
export const fileSourcesKey = 'bcc_file_sources';
export const linkSourcesKey = 'bcc_link_sources';
export const brandingLinkSource = 'bcc_link_source';
export const initAIGeneratedBrandingKey = 'bcc_init_ai_generated_branding';
export const fileDownloadUrlKey = 'bcc_file_download_url';
export const productCatalogMapGenerationStatusKey =
  'bcc_product_catalog_map_generation_status';
export const productCatalogMapGenerationGuidanceMaxLength = 2000;
export const productCatalogMapMaxLength = 4000;
